import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '@/hooks/use-has-permission';
import { HRM_PERMISSIONS } from '@/constant/hr/permissions';
import { ServiceDeskPageShell } from '@/modules/service-desk/shared/components/service-desk-page-shell';
import { IdCardMyApplications } from '../../components/id-card-my-applications/id-card-my-applications';
import { IdCardRequests } from '../../components/id-card-requests/id-card-requests';

export const IdCardPage = () => {
  const navigate = useNavigate();
  const canViewRequests = useHasPermission(HRM_PERMISSIONS.ID_CARD_APPLICATION.VIEW_REQUESTS);
  const canApply = useHasPermission(HRM_PERMISSIONS.ID_CARD_APPLICATION.APPLY);

  return (
    <ServiceDeskPageShell
      titleKey="ID_CARD_APPLICATION"
      requestsTabKey="ID_CARD_REQUESTS"
      canViewRequests={canViewRequests}
      requests={<IdCardRequests />}
      mine={<IdCardMyApplications />}
      onApply={canApply ? () => navigate('/hr/service-desk/id-card/apply') : undefined}
    />
  );
};
